import { Component, Input } from '@angular/core';
import { Media } from '@stuplay';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'media-none',
    templateUrl: './none.component.html',
    styleUrls: ['./none.component.less']
})
export class MediaNoneComponent {
    @Input() media: Media;
    @Input() size: number;
    stockageUrl: string = environment.envVar.API_STOCKAGE_URL;

    constructor() {}

    onClick(e) {
        e.preventDefault();
    }
}
